//Financial Match Challenge	 金融挑战赛
export default {
  name: '金融挑战赛',
  path: '/finContest',
  redirect: '/finContest/admin',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      name: '管理员菜单',
      path: '/finContest/admin',
      redirect: '/finContest/admin/warm-up-query',
      children: [
        {
          name: '热身赛查询',
          path: '/finContest/admin/warm-up-query',
          component: () => import('@/views/manage-finContest/admin/warm-up-query/index.vue'),
        },
        {
          name: '校赛查询',
          path: '/finContest/admin/school-competition-query',
          component: () => import('@/views/manage-finContest/admin/school-competition-query/index.vue'),
        },
        {
          name: '查询往届学生信息',
          path: '/finContest/admin/previous-student',
          component: () => import('@/views/manage-finContest/admin/previous-student/index.vue'),
        },
        {
          name: '省赛查询',
          path: '/finContest/admin/province-competition-query',
          component: () => import('@/views/manage-finContest/admin/province-competition-query/index.vue'),
        },
        {
          name: '晋级国赛查询',
          path: '/finContest/admin/national-qualification-query',
          component: () => import('@/views/manage-finContest/admin/national-qualification-query/index.vue'),
        },
        {
          name: '国赛查询',
          path: '/finContest/admin/national-competition-query',
          component: () => import('@/views/manage-finContest/admin/national-competition-query/index.vue'),
        },
        {
          name: '未组队学生列表',
          path: '/finContest/admin/ungrouped-students',
          component: () => import('@/views/manage-finContest/admin/ungrouped-students/index.vue'),
        },
        {
          name: '文件上传管理',
          path: '/finContest/admin/file-upload-management',
          component: () => import('@/views/manage-finContest/admin/file-upload-management/index.vue'),
        },
        {
          name: '文件上传历史',
          path: '/finContest/admin/file-upload-history',
          component: () => import('@/views/manage-finContest/admin/file-upload-history/index.vue'),
        },
        {
          name: '获奖团队',
          path: '/finContest/admin/award-winning-teams',
          component: () => import('@/views/manage-finContest/admin/award-winning-teams/index.vue'),
        },
        {
          name: '电子合同审核',
          path: '/finContest/admin/electronic-contract-review',
          component: () => import('@/views/manage-finContest/admin/electronic-contract-review/index.vue'),
        },
        {
          name: '电子合同查询',
          path: '/finContest/admin/electronic-contract-query',
          component: () => import('@/views/manage-finContest/admin/electronic-contract-query/index.vue'),
        },
        {
          name: '合同状态变更',
          path: '/finContest/admin/contract-status-change',
          component: () => import('@/views/manage-finContest/admin/contract-status-change/index.vue'),
        },
        {
          name: '电子合同明细',
          path: '/finContest/admin/contract-info',
          component: () => import('@/views/manage-finContest/admin/contract-info/index.vue'),
        },

        {
          name: '违规用户黑名单',
          path: '/finContest/admin/blackList',
          component: () => import('@/views/manage-finContest/admin/illegal-user-blacklist/index.vue'),
        },
        {
          name: '校赛晋级学生查询',
          path: '/finContest/admin/school-promotion',
          component: () => import('@/views/manage-finContest/admin/school-promotion/Index.vue'),
        },
      ],
    },
    {
      name: '领队菜单',
      path: '/finContest/leader',
      redirect: '/finContest/leader/warm-up-query',
      children: [
        {
          name: '查询热身赛学生信息',
          path: '/finContest/leader/warm-up-query',
          component: () => import('@/views/manage-finContest/leader/warm-up-query/index.vue'),
        },
        {
          name: '查询本届校赛学生信息',
          path: '/finContest/leader/current-school',
          component: () => import('@/views/manage-finContest/leader/current-school/index.vue'),
        },
        {
          name: '查询往届学生信息',
          path: '/finContest/leader/previous-student',
          component: () => import('@/views/manage-finContest/leader/previous-student/index.vue'),
        },
        {
          name: '校赛晋级学生查询',
          path: '/finContest/leader/school-promotion',
          component: () => import('@/views/manage-finContest/leader/school-promotion/index.vue'),
        },
        {
          name: '查询省赛团队信息',
          path: '/finContest/leader/provincial-team',
          component: () => import('@/views/manage-finContest/leader/provincial-team/index.vue'),
        },
        {
          name: '查询国赛团队信息',
          path: '/finContest/leader/national-team',
          component: () => import('@/views/manage-finContest/leader/national-team/index.vue'),
        },
        {
          name: '省赛晋级团队查询',
          path: '/finContest/leader/provincial-promotion',
          component: () => import('@/views/manage-finContest/leader/provincial-promotion/index.vue'),
        },
        {
          name: '获奖团队查询',
          path: '/finContest/leader/award-team',
          component: () => import('@/views/manage-finContest/leader/award-team/index.vue'),
        },
        {
          name: '电子证书下载-finContest',
          path: '/finContest/leader/certificate/finContest',
          component: () => import('@/components/certificate/index.vue'),
        },
        {
          name: '文件下载列表',
          path: '/finContest/leader/file-download',
          component: () => import('@/views/manage-finContest/leader/file-download/index.vue'),
        },
      ],
    },
    {
      name: '奖励菜单',
      path: '/finContest/award',
      redirect: '/finContest/award/warm-up-award',
      children: [
        {
          name: '热身赛周榜发奖',
          path: '/finContest/award/warm-up-award',
          component: () => import('@/views/manage-finContest/award/warm-up-award/index.vue'),
        },
        {
          name: '校赛奖金发放',
          path: '/finContest/award/scCashReward',
          component: () => import('@/views/manage-finContest/award/school-cash-prize/index.vue'),
        },
        {
          name: '黑名单',
          path: '/finContest/award/blackList',
          component: () => import('@/views/manage-finContest/award/blackList/index.vue'),
        },
      ],
    },
  ],
};
